import { createContext } from 'react';
import { useGoogleTagManager } from '@hooks/use-google-tag-manager/use-google-tag-manager';

import { GoogleTagManagerContextType, GoogleTagManagerProviderProps } from './google-tag-manager.type';

const GoogleTagManagerContext = createContext<GoogleTagManagerContextType | null>(null);

export const GoogleTagManagerProvider = ({ children }: GoogleTagManagerProviderProps) => {
  const gtm = useGoogleTagManager();

  return <GoogleTagManagerContext.Provider value={gtm}>{children}</GoogleTagManagerContext.Provider>;
};
